import { default as mixpanelBrowser, Mixpanel } from 'mixpanel-browser'
import settings from './settings'

let mixpanel: Mixpanel | null

type MixpanelEvent =
  | 'User Logged In'
  | 'User Logged Out'
  | 'DeepThought Shared'
  | 'DeepThought Who To Follow Searched'
  | 'DeepThought Followed'
  | 'DeepThought Unfollowed'
  | 'DeepThought Filtered Followers'
  | 'DeepThought Filtered Following'
  | 'DeepThought Filtered Unfollowers'
  | 'DeepThought Filtered Engagers'
  | 'DeepThought Check Verified Follower Count Searched'
  | 'DeepThought Payout Predictor Submitted'
  | 'DeepThought Payout Predictor Clicked'
  | 'DeepThought Post Predictor Analyzed'
  | 'DeepThought Post Analytics Clicked'
  | 'DeepThought Follower Growth Clicked'
  | 'DeepThought Recently Joined'
  | 'DeepThought Switched Account'
  | 'Extension Audience Copied'
  | 'Extension Audience Saved'
  | 'Extension Campaign Launched'
  | 'Extension AdAccount Access Granted'
  | 'XProTargeting Download Extension Clicked'
  | 'XProTargeting Event Material Clicked'
  | 'XProTargeting Example Clicked'
  | 'XProTargeting Feedback Clicked'
  | 'XProTargeting Form Submitted'
  | 'XProTargeting Insights Generated'
  | 'XProTargeting Marketing Material Opened'
  | 'XProTargeting Marketing Material Requested'
  | 'XProTargeting Targeting List Child Clicked'
  | 'XProTargeting Targeting List Opened'
  | 'XProTargeting Targeting List Parent Clicked'
  | 'XProTargeting Targeting List Previewed'
  | 'XProTargeting Targeting List Requested'
  | 'XProTargeting Autopilot Insights Generated'
  | 'XProTargeting Theme Toggled'

type MixpanelRegisterProperty =
  | 'geo_location'
  | 'id'
  | 'x_account_ids'
  | 'team_ids'
  | 'handle'
  | 'verified'
  | 'followers'

export function useMixpanel() {
  if (!mixpanel && settings.MODE === 'production' && settings.MIXPANEL_TOKEN) {
    mixpanelBrowser.init(settings.MIXPANEL_TOKEN)
    mixpanel = mixpanelBrowser
  }

  function track_pageview() {
    if (mixpanel) {
      mixpanel.track_pageview()
    }
  }

  function track(event: MixpanelEvent, properties?: Record<string, any>) {
    if (mixpanel) {
      mixpanel.track(event, properties)
    }
  }

  function identify(id: string) {
    if (mixpanel) {
      mixpanel.identify(id)
    }
  }

  function reset() {
    if (mixpanel) {
      mixpanel.reset()
    }
  }

  function register(properties: Partial<Record<MixpanelRegisterProperty, any>>) {
    if (mixpanel) {
      mixpanel.register(properties)
    }
  }

  return { track, track_pageview, identify, reset, register }
}
